/**
 * Resource điều chỉnh kinh phí
 */
export default {
  Title: 'Điều chỉnh kinh phí',
  GetAdjustData: 'Lấy dữ liệu điều chỉnh',
  AdjustDate: 'Ngày điều chỉnh',
  AdjustNo: 'Số điều chỉnh',
  AdjustTime: 'Thời gian điều chỉnh',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  GetData: 'Lấy dữ liệu',
  Description: 'Diễn giải',
  VoucherRef: 'CT tham chiếu',
  VoucherRefTitle: 'Chứng từ tham chiếu',
  RefDate: 'Ngày CT',
  RefDateTitle: 'Ngày chứng từ',
  PostedDate: 'Ngày HT',
  PostedDateTitle: 'Ngày hạch toán',
  RefNo: 'Số CT',
  RefNoTitle: 'Số chứng từ',
  DeleteTitle: 'Xóa chứng từ',
  MsgDelete: 'Bạn có thực sự muốn xóa chứng từ này không?',
  MsgDeleteOne: 'Bạn có muốn xóa chứng từ <b style="color: #34A853;">&lt;{0}&gt;</b> không?',
  MsgDeleteMulti: 'Bạn có thực sự muốn xóa các chứng từ đã chọn không?',
  MsgEmptyAdjustDataTitle: 'Không có dữ liệu',
  MsgEmptyAdjustDataBody: 'Không có chỉ tiêu nào cần điều chỉnh',
};
